var _DictionaryEnumerator_dictionary, _DictionaryEnumerator_keyEnumerator;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import ArrayEnumerator from "./ArrayEnumerator";
import EnumeratorBase from "./EnumeratorBase";
export default class DictionaryEnumerator extends EnumeratorBase {
    constructor(dictionary) {
        super();
        _DictionaryEnumerator_dictionary.set(this, void 0);
        _DictionaryEnumerator_keyEnumerator.set(this, void 0);
        __classPrivateFieldSet(this, _DictionaryEnumerator_dictionary, dictionary, "f");
        __classPrivateFieldSet(this, _DictionaryEnumerator_keyEnumerator, new ArrayEnumerator(dictionary.keys), "f");
    }
    get current() {
        const key = __classPrivateFieldGet(this, _DictionaryEnumerator_keyEnumerator, "f").current;
        const value = __classPrivateFieldGet(this, _DictionaryEnumerator_dictionary, "f").itemByKey(key);
        return { key, value };
    }
    moveNext() {
        return __classPrivateFieldGet(this, _DictionaryEnumerator_keyEnumerator, "f").moveNext();
    }
    peek() {
        const key = __classPrivateFieldGet(this, _DictionaryEnumerator_keyEnumerator, "f").peek();
        if (key === undefined) {
            return;
        }
        const value = __classPrivateFieldGet(this, _DictionaryEnumerator_dictionary, "f").itemByKey(key);
        return { key, value };
    }
    reset() {
        __classPrivateFieldGet(this, _DictionaryEnumerator_keyEnumerator, "f").reset();
    }
}
_DictionaryEnumerator_dictionary = new WeakMap(), _DictionaryEnumerator_keyEnumerator = new WeakMap();
